import React, { useContext } from 'react'
import { View, Text, StyleSheet } from 'react-native'
import { Value } from '@ecountabl/lib'
import { ThemeContext } from '../utility/context/ThemeContext'
import { ValueBadge } from './value-badge'

type ValueLabelProps = {
  value: Value
}

export const ValueLabelWithIcon = ({ value }: ValueLabelProps): React.ReactElement => {
  const { theme } = useContext(ThemeContext)
  return (
    <View style={styles.wrap}>
      <ValueBadge
        color={value.color}
        accentFallbackColor={theme.colors.primary}
        icon={value.icon}
        label={value.label}
        size={35}
        iconSize={20}
      />
      <Text style={{
        fontWeight: 'bold',
        paddingHorizontal: 8,
        fontFamily: 'poppins-semi-bold',
        color: theme.colors.textMain
      }}>
        {value.label}
      </Text>
    </View>
  )
}

const styles = StyleSheet.create({
  wrap: {
    flexDirection: 'row',
    alignItems: 'center'
  },
})